import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VIcon, [_vm._v("fal fa-" + _vm._s(_vm.data))]);
};
var staticRenderFns = [];
export { render, staticRenderFns };